import React from "react";
import { ContentTreeTemplate } from "themes/application/producer/pages";
import { ContentTreeViewStore } from "application/producer/stores";
import { setCurrentView } from "mrb/core";

@setCurrentView(
    (rootStore, componentProps) => new ContentTreeViewStore(rootStore, componentProps),
    "contentTreeViewStore"
)
class ContentTree extends React.Component {
    render() {
        return <ContentTreeTemplate {...this.props} />;
    }
}

export default ContentTree;
